import { render, staticRenderFns } from "./chateau-poujeaux.vue?vue&type=template&id=221e217c&scoped=true"
import script from "./chateau-poujeaux.vue?vue&type=script&lang=js"
export * from "./chateau-poujeaux.vue?vue&type=script&lang=js"
import style0 from "./chateau-poujeaux.vue?vue&type=style&index=0&id=221e217c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221e217c",
  null
  
)

export default component.exports